import React, { Component } from "react";
import { Grid } from "@mui/material";
import CtTxt from "./CustomTool/CtTxt";
import CtDtp from "./CustomTool/CtDtp";
import CtCmb from "./CustomTool/CtCmb";
import CtBtn from "./CustomTool/CtBtn";
import TableList from "./CustomTool/TableList";
import { withRouter } from "../HOC/withRouter";
import { connect } from "react-redux";
import {
  mapSetActiveMenu_MenuVisibility_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import CtTxtNum from "./CustomTool/CtTxtNum";
import Progress from "./CustomTool/Progress";

class TransportMaster extends Component {
  state = {
    City: [],
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      // { id: 'bint_srno', label: 'SR NO' },
      { id: "transportname", label: "Transport Name" },
      { id: "personname", label: "Person Name" },
      { id: "address", label: "Address" },
      { id: "city", label: "City" },
      { id: "gstno", label: "GST No." },
      { id: "mobileno1", label: "Mobile No. 1" },
      { id: "mobileno2", label: "Mobile No. 2" },
    ],
    searchData: {
      transportname: "",
      personname: "",
      address: "",
      city: "",
      gstno: "",
      mobileno1: "",
      mobileno2: "",
    },
    rows: [],
    searchColumns: [],
    rowsCount: 0,
    counter: 0,
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : Transport Master";
    this.props.setActiveMenu("TransportMaster");
    this.setSearchColumns();
    this.props.verifyUserID(
      undefined,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  //#endregion Component
  //#region Handle
  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row) => {
        if (
          searchOpen === true &&
          (this.state.searchData.transportname.length === 0 ||
            (row["transportname"]
              ? row["transportname"]
                  .toString()
                  .toLowerCase()
                  .includes(this.state.searchData.transportname.toLowerCase())
              : false)) &&
          (this.state.searchData.personname.length === 0 ||
            (row["personname"]
              ? row["personname"]
                  .toString()
                  .toLowerCase()
                  .includes(this.state.searchData.personname.toLowerCase())
              : false)) &&
          (this.state.searchData.address.length === 0 ||
            (row["address"]
              ? row["address"]
                  .toString()
                  .toLowerCase()
                  .includes(this.state.searchData.address.toLowerCase())
              : false)) &&
          (this.state.searchData.city.length === 0 ||
            (row["city"]
              ? row["city"]
                  .toString()
                  .toLowerCase()
                  .includes(this.state.searchData.city.toLowerCase())
              : false)) &&
          (this.state.searchData.gstno.length === 0 ||
            (row["gstno"]
              ? row["gstno"]
                  .toString()
                  .toLowerCase()
                  .includes(this.state.searchData.gstno.toLowerCase())
              : false)) &&
          (this.state.searchData.mobileno1.length === 0 ||
            (row["mobileno1"]
              ? row["mobileno1"]
                  .toString()
                  .toLowerCase()
                  .includes(this.state.searchData.mobileno1.toLowerCase())
              : false)) &&
          (this.state.searchData.mobileno2.length === 0 ||
            (Number(row["mobileno2"])
              ? row["mobileno2"].includes(this.state.searchData.mobileno2)
              : false))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {
          // console.log('searchRows on end of Function', searchRows)
        }
      );
    } else {
      this.setState({ searchOpen });
    }
  };

  handleOnSearchInputChange = (e) => {
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen);
        // console.log(this.state.searchData)
      }
    );
  };
  //#endregion

  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      {
        cType: "CtTxt",
        id: "transportname",
        label: "Transport Name",
        value: this.state.searchData.transportname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "personname",
        label: "Person Name",
        value: this.state.searchData.personname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "address",
        label: "Address",
        value: this.state.searchData.address,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "city",
        label: "City",
        items: this.state.City,
        value: this.state.searchData.city,
        handleOnChange: this.handleOnSearchInputChange,
        width: "260",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "gstno",
        label: "GST No.",
        value: this.state.searchData.gstno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "mobileno1",
        label: "Mobile No. 1",
        value: this.state.searchData.mobileno1,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "mobileno2",
        label: "Mobile No. 2",
        value: this.state.searchData.mobileno2,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      }
    );
    this.setState({ searchColumns });
  };
  render() {
    return (
      <form>
        {/* <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        /> */}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b>Transport Master</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0}
          marginTop={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxt
                  id="txtTransportName"
                  label="Transport Name"
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={100}
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtPersonName"
                  label="Person Name"
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={100}
                />
              </Grid>
              <Grid item>
                <CtMultiLineText
                  id="txtAddress"
                  label="Address"
                  handleOnChange={this.handleOnChange}
                  width={350}
                  maxLength={1000}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtCmb
                  id="cmbCity"
                  label="City"
                  items={this.state.City}
                  width={150}
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtGSTNo"
                  label="GST No."
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={100}
                />
              </Grid>
              <Grid item>
                <CtTxtNum
                  id="txtMobileNo1"
                  label="Mobile No. 1"
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={100}
                />
              </Grid>
              <Grid item>
                <CtTxtNum
                  id="txtMobileNo2"
                  label="Mobile No. 2"
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={100}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={2}
              marginTop={2}
            >
              <Grid item>
                <CtBtn label="Save" />
              </Grid>
              <Grid item>
                <CtBtn label="New" />
              </Grid>
              <Grid item>
                <CtBtn label="Delete" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          marginTop={5}
        >
          <TableList
            columns={this.state.columns}
            counter={this.state.counter}
            // rows={rows}
            // rowsCount={rowsCount}
            rowsPerPage={this.state.rowsPerPage}
            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
            handleOnActionClick={this.handleARDonActionClick}
            actionList={this.state.actionList}
            keyColumn={this.state.keyColumn}
            handleOnSearchChange={this.handleOnSearchChange}
            searchColumns={this.state.searchColumns}
            searchData={this.state.searchData}
            provideSearch={true}
            // handleOnNewEntryClick={this.handleOnNewEntryClick}
            // toolTipNewEntry='New Product Entry'
          />
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(withRouter(TransportMaster)));
